import { useNavigate } from 'react-router-dom';

export const useUnidEntitySearchController = () => {
    const navigate = useNavigate();

    function navigateToCreate() {
        navigate('/unidades-entidade/adicionar');
    }

    return {
        navigateToCreate
    };
}
